<script>

/**
 * Nav-bar Component
 */
export default {
  props: {
    pages: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true
    },
    setSlide: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      slide: this.setSlide,
    };
  },
  methods: {
    onSlideStart(e) {
      this.$emit('sliding-start', e);
    }
  }
};
</script>

<template>
  <b-row>
    <b-col>
      <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="0"
          controls
          indicators
          img-width="800"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
      >
        <!-- Text slides with image -->
        <b-carousel-slide
            v-for="image in pages"
            :key="image.id"
            :caption="image.filename"
            img-center
        >
          <template #img>
            <b-img-lazy class="d-block img-fluid w-100" :src="`/api/${type}/${image.id}/image`"
            ></b-img-lazy>
          </template>
        </b-carousel-slide>

      </b-carousel>
    </b-col>
  </b-row>
</template>

<style>
.carousel-item > img {
  margin: 0 auto !important;
  width: auto !important;
}

.carousel-caption {
  position: initial !important;
}

.carousel-control-prev-icon, .carousel-control-next-icon {
  background-color: black;
}
</style>